<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand bg-gradient-info"
  >
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler"
             :class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner mb-3">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      
    </b-navbar-nav>
    <b-navbar-nav id="text-right">
      <h1 class="display-2 pt-1 pb-3">HALO</h1>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
// import { CollapseTransition } from 'vue2-transitions';
import { BaseNav } from '@/components/Argon';

export default {
  components: {
    // CollapseTransition,
    BaseNav,
    // Modal
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ''
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: bold;
  color: #f4f5f7;
}

#text-right {
  margin-left: auto;
}
</style>